import { useFeatureFlag } from '@order/LaunchDarkly';

export const useIsPreviewModeEnabled = () => {
  return useFeatureFlag('permanent-contentful-preview-enabled');
};
